import { ChangeDetectionStrategy, Component, Input, Renderer2, ViewChild } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
  selector: 'flo-search-input',
  templateUrl: './search-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SearchInputComponent,
      multi: true
    }
  ]
})
export class SearchInputComponent implements ControlValueAccessor {
  private _placeholder: string
  private _resultText: string

  @ViewChild('input', { static: true }) _input: any
  @ViewChild('icon', { static: true }) _icon: any

  @Input() disabled: boolean

  @Input()
  set placeholder(val: string) {
    this._placeholder = val
  }
  get placeholder() {
    return this._placeholder || 'Search'
  }

  @Input()
  set resultText(val: string) {
    this._resultText = val
  }
  get resultText() {
    return this._resultText
  }

  onChange: any

  get inputElement() {
    return this._input.nativeElement as HTMLInputElement
  }

  get icon() {
    return this._icon.nativeElement as HTMLSpanElement
  }

  change($event: any) {
    this.onChange($event.target.value)
  }

  writeValue(obj: string): void {
    this.renderer.setProperty(this.inputElement, 'value', obj)
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    // void
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
    if (!this.disabled) {
      this.renderer.removeClass(this.icon, 'disabled')
      return
    }
    this.renderer.removeClass(this.icon, 'primary-color-text')
    this.renderer.addClass(this.icon, 'disabled')
  }

  constructor(private renderer: Renderer2) {}
}
